module.exports = __webpack_public_path__ + "static/media/fff_about_info.87824530.png";